import $ from "jquery";
// import "@fontsource-variable/alegreya";
import "@fontsource/alegreya/400.css";
import "@fontsource/alegreya/500.css";
import "@fontsource/alegreya/600.css";
import "@fontsource/alegreya/700.css";
import "@fontsource/alegreya-sans/400.css";
import "@fontsource/alegreya-sans/500.css";
import "@fontsource/alegreya-sans/700.css";
import "@fontsource/alegreya-sans/500-italic.css";
import "../styles/main.scss";
import "./features/modal-manager";
import "./features/isi";
// import "./features/cookies";
// import "./features/learn_more_modal";
import "./vimeo-tracking";
import "./features/hspt_obesity_discussion";
import "./features/stay_informed";
import "./features/share_journey";
import "bootstrap";
import "./features/menu";
import "./features/geolocation";
import "./features/bmi-questions";
import "./features/get-contrave-cupon";
import "./features/onesizedoesnotfit";
import "./features/leaving-contrave";
import "./features/payingSteps";
import "./features/success-stories";
// import "./ostrochat";
console.log("ok");
